import React,{ useEffect, useState } from 'react';
const AddBall = ({ formValues, handleBallChange }) => {
  
  return (
    <div className="input-container">
        <label className="input-label">貢丸</label>
        <input
            type="number"
            value={formValues.Ball ? formValues.Ball : 0}
            onChange={handleBallChange}
            onFocus={(e) => e.target.select()}
            className="input-field"
        />
    </div>

  );
};

export default AddBall;
